import React from "react";
import styled from "styled-components";

const CustomSelectOption = styled.div`
  height: auto;
  display: inline-flex;
  align-items: center;
  position: relative;
  padding: 2px;
  font-size: 13px;
  border: 1px solid
    ${({ isSelected, isF, fromRestaurant }) =>
      isF && !fromRestaurant ? "#D94B4B" : isSelected ? "#99B0AD" : "#99B0AD"};
  border-radius: 5px;
  margin-bottom: 5px;
  cursor: ${({ isF, fromRestaurant }) =>
    isF && !fromRestaurant ? "default" : "pointer"};
  pointer-events: ${({ isF, fromRestaurant }) =>
    isF && !fromRestaurant ? "none" : "auto"};
  background-color: ${({ isSelected, isF, fromRestaurant }) =>
    isF && !fromRestaurant
      ? "#D94B4B"
      : isSelected
      ? "#99B0AD"
      : "transparent"};
  color: ${({ isSelected, isF, fromRestaurant }) =>
    isF && !fromRestaurant ? "white" : isSelected ? "#FAF6E9" : "black"};
  transition: all 0.2s ease-in-out;
  margin-right: 2px;

  &:hover {
    border-color: #99b0ad;
  }
`;

const CustomSelectText = styled.span`
  margin-right: 5px;

  span {
    white-space: nowrap;
  }
`;

function CustomSelect({
  items,
  onSelectChange,
  selectedItem,
  getBorderColor,
  // removed "update" prop collision with react-spring
  setUpdate = null,
  from_restaurant = false,
}) {
  const handleItemClick = (item) => {
    // Toggle off if clicking the same item; set to "" as requested
    const nextValue = selectedItem === item ? "" : item;
    onSelectChange(nextValue);

    // Bump an external counter if provided
    if (typeof setUpdate === "function") {
      setUpdate((prev) => (typeof prev === "number" ? prev + 1 : 1));
    }
  };

  return (
    <div style={{ maxWidth: "100%", display: "flex", flexWrap: "wrap" }}>
      {items &&
        items.map((item, index) => (
          <CustomSelectOption
            key={`${item}-${index}`}
            id={`custom-select-option-${index}`}
            isSelected={selectedItem === item}
            onClick={() => handleItemClick(item)}
            borderColor={getBorderColor ? getBorderColor(item) : undefined}
            isF={item.endsWith("/f")}
            fromRestaurant={from_restaurant}
          >
            <CustomSelectText>
              {item === "Lunch" || item === "Lunch/f"
                ? "Almoço"
                : item === "Dinner" || item === "Dinner/f"
                ? "Jantar"
                : item === "Breakfast" || item === "Breakfast/f"
                ? "Pequeno Almoço"
                : item === "reservation"
                ? "Reserva"
                : item === "waiting_list"
                ? "Fila à porta"
                : item.endsWith("/f")
                ? item.slice(0, -2)
                : item}
              {item.endsWith("/f") && !from_restaurant && (
                <span style={{ color: "white" }}> | Lotado*</span>
              )}
            </CustomSelectText>
          </CustomSelectOption>
        ))}
    </div>
  );
}

export default CustomSelect;
